export function populateFormErrors(errors, errorResponse) {
  Object.keys(errors).forEach((key) => {
    if (errorResponse.hasOwnProperty(key)) {
      const errorMessage = Array.isArray(errorResponse[key])
        ? errorResponse[key][0]
        : errorResponse[key];
      errors[key] = errorMessage;
    }
  });
  return errors;
}

export function resetFormErrors(errors, resetValue = "") {
  Object.keys(errors).forEach((key) => {
    errors[key] = resetValue;
  });
  return errors;
}
